import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as WarningIcon} from 'assets/svg/warning.svg';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {Modal} from 'components/ui-kit/Modal';

import {colors} from 'theme';

import {
    Content,
    Footer,
    InfoWrapper,
    WarningCard,
    WarningCardContent,
    WarningCardIcon,
    WarningDescription,
    WarningTitle,
} from './styled';

type UnlockProductModalProps = {
    isPending: boolean;
    onClose: () => void;
    onConfirm: () => void;
    renderInline?: boolean;
    show: boolean;
};

export const UnlockProductModal = ({
    isPending,
    onClose,
    onConfirm,
    renderInline = false,
    show,
}: UnlockProductModalProps) => {
    const {t} = useTranslation();

    const content = (
        <Content>
            <InfoWrapper>
                <WarningCard>
                    <WarningCardIcon>
                        <Icon
                            source={WarningIcon}
                            width={20}
                            height={20}
                            fillColor={colors.warningOrangeSecondary}
                            strokeColor={colors.warningOrange}
                        />
                    </WarningCardIcon>
                    <WarningCardContent>
                        <WarningTitle>
                            {t('pages.registries.unlockProductModal.warningTitle')}
                        </WarningTitle>
                        <WarningDescription>
                            {t('pages.registries.unlockProductModal.warningDescription')}
                        </WarningDescription>
                    </WarningCardContent>
                </WarningCard>
            </InfoWrapper>
            <Footer>
                <Button
                    variant={ButtonVariant.Outline}
                    type="button"
                    disabled={isPending}
                    onClick={onClose}
                >
                    {t('components.form.Cancel')}
                </Button>
                <Button
                    variant={ButtonVariant.Normal}
                    type="button"
                    disabled={isPending}
                    onClick={onConfirm}
                >
                    {t('pages.registries.unlockProductModal.confirmButton')}
                </Button>
            </Footer>
        </Content>
    );

    if (renderInline) return content;

    return (
        <Modal show={show} onClose={onClose} modalWidth={0}>
            {content}
        </Modal>
    );
};
